var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTarget = function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 10,
    cy: 10,
    r: 1.304
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    cx: 10,
    cy: 10,
    r: 5.652
  }))));
};
export default SvgTarget;